import RatingContainer from "../../../Components/BonusUi/Rating/RatingContainer";

const Rating = () => {
  return <RatingContainer />;
};

export default Rating;
